<!-- START HEADER-->
<header class="header" app-hrms-header></header>
<!-- END HEADER-->
<!-- START SIDEBAR-->
<nav class="page-sidebar" id="sidebar" app-hrms-sidebar></nav>
<!-- END SIDEBAR-->

<!-- START PAGE CONTENT-->
<div class="content-wrapper">
    <router-outlet></router-outlet>
    <!-- <div app-banner></div> -->
    <footer class="page-footer" app-hrms-footer></footer>
</div>
<!-- END PAGE CONTENT-->